import React from "react";
import { Row, Col, Tooltip } from "antd";
import {
  InfoCircleOutlined,
  ApartmentOutlined,
  AppstoreOutlined,
  SlidersOutlined,
  ScheduleOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "../../styles/db.css";
import PageHeader from "../../components/generic/PageHeader";

// ─── Scalable admin registry — add a card with one entry ──────
const ADMIN_SECTIONS = [
  {
    title: "SYSTEM",
    cards: [
      {
        label: "Projects",
        desc: "Create and manage projects — the lens that scopes the whole app.",
        icon: <AppstoreOutlined />,
        path: "/admin/projects",
      },
      {
        label: "Environments",
        desc: "Manage environments, folder paths and DB connections.",
        icon: <ApartmentOutlined />,
        path: "/environments",
      },
      {
        label: "Settings",
        desc: "Document storage and application configuration.",
        icon: <SlidersOutlined />,
        path: "/admin/settings",
      },
      {
        label: "Jobs",
        desc: "View the job queue and run history.",
        icon: <ScheduleOutlined />,
        path: "/jobs",
      },
      {
        label: "Agents",
        desc: "Create & revoke on-prem desktop automation agent keys.",
        icon: <RobotOutlined />,
        path: "/admin/agents",
      },
    ],
  },
];

function AdminCard({ card, onClick }) {
  return (
    <div
      onClick={onClick}
      style={{
        background: "#fff",
        border: "1px solid var(--color-border-tertiary, #E5E7EB)",
        borderRadius: 12,
        padding: "18px 18px 16px",
        cursor: "pointer",
        transition: "border-color .15s, box-shadow .15s, transform .15s",
        display: "flex",
        flexDirection: "column",
        gap: 8,
        minHeight: 120,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = "#0B1F3A";
        e.currentTarget.style.boxShadow = "0 4px 16px rgba(11,31,58,0.10)";
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = "var(--color-border-tertiary, #E5E7EB)";
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.transform = "none";
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 34,
            height: 34,
            borderRadius: 8,
            background: "rgba(24, 95, 165, 0.10)",
            color: "#185FA5",
            fontSize: 17,
            flexShrink: 0,
          }}
        >
          {card.icon}
        </span>
        <span style={{ fontSize: 15, fontWeight: 600, color: "#0B1F3A" }}>
          {card.label}
        </span>
      </div>
      <div
        style={{
          fontSize: 13,
          color: "var(--color-text-secondary, #6B7280)",
          lineHeight: 1.45,
        }}
      >
        {card.desc}
      </div>
    </div>
  );
}

function AdminHome() {
  const navigate = useNavigate();

  return (
    <div className="db-container">
      <PageHeader
        icon={<ApartmentOutlined />}
        title="Administration"
        tooltip="Administration and configuration"
      />

      {ADMIN_SECTIONS.map((section) => (
        <div key={section.title} style={{ marginBottom: 28 }}>
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              letterSpacing: 0.6,
              color: "var(--color-text-secondary, #9CA3AF)",
              textTransform: "uppercase",
              marginBottom: 12,
            }}
          >
            {section.title}
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
              gap: 16,
            }}
          >
            {section.cards.map((card) => (
              <AdminCard
                key={card.path}
                card={card}
                onClick={() => navigate(card.path)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AdminHome;
